export function handleApiError(error) {
  const { response } = error;

  if (response && response.data) {
    const { message, statusCode } = response.data;

    return { type: "error", text: message, statusCode };
  }

  // Handle network errors or errors without response
  return { 
    type: "error", 
    text: error.message || "Erro ao processar requisição", 
    statusCode: 500 
  };
}

export function handleApiSuccess(data) {
  if (data.message) {
    const { message, statusCode } = data;

    return { type: "success", text: message, statusCode };
  }
}
